import { useMemo } from 'react';
import { tp } from '@/shared/lib/typograf';

export function useTypograf(str: string) {
    return useMemo(() => tp(str), [str]);
}
